import { useState } from 'react';
import styled from 'styled-components';
import type { ICustomPanel } from './types';

/**
 * Right-segment host for host-injected panels (Faza 3 "Custom panel"). No
 * Comments/Summary content here yet (not ported) — this only renders whatever
 * `customPanels` the host (code or the UI-builder adapter) supplies, tab-switched
 * when there's more than one.
 */
interface ICustomPanelsProps {
  panels: ICustomPanel[];
}

const CustomPanels: React.FC<ICustomPanelsProps> = ({ panels }) => {
  const [active, setActive] = useState(0);
  const current = panels[Math.min(active, panels.length - 1)];

  return (
    <Wrapper>
      <TabsRow>
        {panels.map((p, i) => (
          <TabBtn key={i} $active={i === active} onClick={() => setActive(i)}>
            {p.header}
          </TabBtn>
        ))}
      </TabsRow>
      <Body>{current?.render()}</Body>
    </Wrapper>
  );
};

export default CustomPanels;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${({ theme }) => theme.colors.surface};
`;

const TabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 6px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  flex-shrink: 0;
  overflow-x: auto;
`;

const TabBtn = styled.button<{ $active: boolean }>`
  flex-shrink: 0;
  padding: 4px 10px;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  cursor: pointer;
  color: ${({ theme, $active }) => ($active ? theme.colors.primaryActive : theme.colors.textSecondary)};
  background: ${({ theme, $active }) => ($active ? theme.colors.primaryLight : 'transparent')};

  &:hover {
    background: ${({ theme, $active }) => ($active ? theme.colors.primaryLight : theme.colors.cardHover)};
  }
`;

const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: ${({ theme }) => theme.spacing.sm};
`;
